import { ENRICHMENT_ROOT_API_PREFIX } from '@aibees/elephant/constants';
import { useEnrichmentMetadataStore } from '@aibees/elephant/store/enrichment-metadata';
import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import {
  Enrichment,
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback } from 'react';

export interface BrowseEnrichmentRequest extends PaginationRequest {
  search?: string;
  id?: string;
  type?: EnrichmentTypeEnum;
  userId?: string;
  visibility?: string;
}

export function useBrowseEnrichmentApi(
  params: BrowseEnrichmentRequest,
  options?: QueryOptions
) {
  params.page = params.page || 0;
  params.size = params.size || 20;
  const { page, size, sort, search, id, visibility, type, userId } = params;
  const workspaceId = useWorkspace()?.id;

  const { setMetadata } = useEnrichmentMetadataStore();
  return useBaseQuery<typeof params, PaginationResponse<Enrichment>>(
    [
      useBrowseEnrichmentApi.name,
      sort,
      page,
      size,
      search,
      id,
      type,
      userId,
      visibility,
    ],
    {
      url: ENRICHMENT_ROOT_API_PREFIX.replace(':wid', String(workspaceId)),
      params: {
        page,
        size,
        sort,
        search: id,
        type,
        userId,
        visibility,
      },
    },
    {
      ...options,
      select: useCallback(
        (data: PaginationResponse<Enrichment>) => {
          setMetadata(data.metadata);
          return data;
        },
        [setMetadata]
      ),
    }
  );
}
